import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from './stores/auth';
import { setDocumentTitle } from './language';
import AppLayout from './components/Layout/AppLayout';
import IndoorStory from './views/IndoorStory';
import Home from './views/Home';
import Login from './views/Login';
import Register from './views/Register';
import MapList from './views/maps/MapList';
import Subscription from './views/subscription/Subscription';
import Billing from './views/billing/Billing';
import Sdk from './views/api/Sdk';
import Notifications from './views/notifications/Notifications';
import EditorPage from './views/editor/EditorPage';
import SdkDoc from './views/SdkDoc';
import SupportPage from './views/support/SupportPage';

function App() {
  const { token } = useAuthStore();
  const location = useLocation();

  // 路由变化时更新页面标题
  useEffect(() => {
    setDocumentTitle(location.pathname);
  }, [location.pathname]);

  return (
    <Routes>
      {/* 沉浸式 3D 展示页 */}
      <Route path="/" element={<IndoorStory />} />
      {/* SDK 文档 - 无需登录 */}
      <Route path="/sdk-doc" element={<SdkDoc />} />
      {/* 原首页 */}
      <Route path="/home" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/editor/example" element={<EditorPage isExampleRoute />} />
      <Route
        path="/editor/:mapId"
        element={token ? <EditorPage /> : <Navigate to="/login" replace />}
      />
      {/* 需要登录的路由 */}
      <Route
        path="/*"
        element={
          token ? (
            <AppLayout>
              <Routes>
                <Route path="/maps" element={<MapList />} />
                <Route path="/subscription" element={<Subscription />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/sdk" element={<Sdk />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/support" element={<SupportPage />} />
                <Route path="*" element={<Navigate to="/maps" replace />} />
              </Routes>
            </AppLayout>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}

export default App;
